import type { TAnalyticsMyRequirementBE } from '@onesource/schemas';
import { FIT_FRONTEND_URL, PROGRAMS_FRONTEND_URL, RYC_FRONTEND_URL } from 'src/config';

export interface RequirementLink {
  href: string;
  /** True when the content lives in another app (opens in a new tab). */
  external: boolean;
}

/**
 * Where a requirement's content lives. SPACES content is a members-app path
 * the API already built; FIT / RYC / PROGRAMS content is in its own app, so
 * the link is assembled here from the environment URLs — the same routes the
 * dashboard's activity views use (`/classes/details`, `/library/details`).
 */
export const getRequirementLink = (req: TAnalyticsMyRequirementBE): RequirementLink | null => {
  if (req.href) {
    return { href: req.href, external: false };
  }
  if (!req.contentId) {
    return null;
  }
  switch (req.source) {
    case 'RYC': {
      return RYC_FRONTEND_URL ? { href: `${RYC_FRONTEND_URL}/library/details/${req.contentId}`, external: true } : null;
    }
    case 'FIT': {
      if (!FIT_FRONTEND_URL) {
        return null;
      }
      const path = req.contentType === 'playlist' ? `/playlists/${req.contentId}` : `/classes/details/${req.contentId}`;
      return { href: `${FIT_FRONTEND_URL}${path}`, external: true };
    }
    case 'PROGRAMS': {
      return PROGRAMS_FRONTEND_URL ? { href: PROGRAMS_FRONTEND_URL, external: true } : null;
    }
    default: {
      return null;
    }
  }
};
